import gql from 'graphql-tag'

export const ADD_BANK_ACCOUNT = gql`
  mutation($data: people_profile_banks_insert_input!) {
    insert_people_profile_banks_one(object: $data) {
      id
    }
  }
`
